<template>
  <v-tabs centered center-active v-model="activeCoinTab" class="dealsTab">
    <v-tab v-for="coin of coins" :key="'tab-' + coin" @click="$store.state.selectedCoins = [coin]">{{coin}}</v-tab>
    <v-tab-item  v-for="coin of coins" :key="'tab-item-' + coin">
      <coin-summary :coin="coin" currency="USD" hide-coin-toggle style="padding: 10px;" />

<!--      <v-row justify="center">-->
<!--        <v-card class="diagramTitle d-inline-flex justify-center pa-2 display-1 font-weight-bold">-->
<!--          <div>Market at a glance</div>-->
<!--        </v-card>-->
<!--      </v-row>-->
      <summary-chart :summary="getSummary(coin)" :coin="coin" />

      <div class="pa-2 homeNum">
        <v-row
                justify="space-between"
                align="center"
                align-content="center"
                class="caption d-flex"
                style="margin: 0;"
        >
          <v-col cols="4" sm="3"><v-chip small color="#ffe500" style="margin-left: -5px!important;" class="ma-2 font-weight-bold">Spot Contracts</v-chip></v-col>
          <v-col cols="4" sm="3">Unit Price(VWAP)</v-col>
          <v-col cols="3" v-if="$vuetify.breakpoint.smAndUp">Volume(24h)</v-col>
          <v-col cols="4" sm="3">Premium / Discount</v-col>
        </v-row>
        <v-row v-for="nicehash of findContracts('REALTIME', coin)" :key="nicehash.id" justify="space-between" align="center" align-content="center" class="homeDeal v-card--hover" @click="goToNicehash(nicehash, coin)">
          <v-col cols="4" sm="3">Real time <v-chip small color="cyan lighten-4">NiceHash</v-chip></v-col>
          <v-col cols="4" sm="3">{{nicehash.priceUsd | unitPrice(coin)}}<span class="grey--text"> (/{{blockchain[coin].unit}}/Day)</span></v-col>
          <v-col cols="3" v-if="$vuetify.breakpoint.smAndUp">{{nicehash.volume | hashrate(coin, false)}}<span class="grey--text"> {{blockchain[coin].unit}}</span></v-col>
          <v-col cols="4" sm="3" class="dealROI">
            <colored :value="nicehash.discount" format="percent" />
          </v-col>
        </v-row>

        <v-chip small color="#ffe500" class="ma-2 font-weight-bold">Forward Contracts</v-chip>
        <v-row
          justify="space-between"
          align="center"
          align-content="center"
          class="caption d-flex"
          style="margin: 0;"
        >
          <v-col cols="3">Contract Maturities</v-col>
          <v-col cols="3">Best Unit Price</v-col>
          <v-col cols="3" class="costCol">Cost Basis</v-col>
          <v-menu offset-y>
            <template v-slot:activator="{ on }">
              <v-col cols="3" style="text-align:center;">
                {{slot2[0]}}
                <v-icon v-on="on" class="body-1 mx-1">mdi-arrow-down-drop-circle-outline</v-icon>
              </v-col>
            </template>
            <v-list>
              <v-list-item v-for="([title], idx) of slot2Menu"
                           :key="title"
                           @click="$store.commit('product/selectSlot', { slot: 2, idx })"
              >
                <v-list-item-title>{{title}}</v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>

<!--          <v-col cols="3" style="text-align:center;">Expected ROI</v-col>-->
        </v-row>
       
        <v-row v-for="(c, idx) in getSummary(coin).contracts" @click="jump(coin, c.duration)" :key="idx" justify="space-between"  align="center" align-content="center" class="homeDeal v-card--hover">
          <v-col cols="4" sm="3">{{c.durationAlias}} <v-chip small color="cyan lighten-4">{{getSummary(coin).durationIssuers.get(c.durationAlias).size}} Platforms</v-chip></v-col>
          <v-col cols="4" sm="3">{{c.daily.preHalving.cost | unitPrice(coin)}} <span class="grey--text">(/{{blockchain[coin].unit}}/Day)</span></v-col>
          <v-col cols="3" class="costCol">{{c.costBasis | price('USD', 2)}} <span class="grey--text">per {{coin}}</span></v-col>
          <v-col cols="4" sm="3" class="dealROI">
            <colored :value="c[slot2[1]] || slot2[1](c)" :format="slot2[2] || 'percent'" />
          </v-col>
        </v-row>

        <v-chip small color="#ffe500" class="ma-2 font-weight-bold">Lifetime Contracts</v-chip>
        <v-row
                justify="space-between"
                align="center"
                align-content="center"
                class="caption d-flex"
                style="margin: 0;"
        >
          <v-col cols="4" sm="3">Machine</v-col>
          <v-col cols="4" sm="3">Unit Price(Last Trade)</v-col>
          <v-col cols="3" v-if="$vuetify.breakpoint.smAndUp">Volume(24h)</v-col>
          <v-col cols="4" sm="3">Breakeven Days</v-col>
        </v-row>
        <v-row v-for="c of findContracts('LIFETIME', coin)" :style="{ display: c.priceUsd > 0 ? null : 'none' }" @click="goToLifetime(c.id)" :key="c.id" justify="space-between" align="center" align-content="center" class="homeDeal v-card--hover">
          <v-col cols="4" sm="3">{{c.name}} <v-chip small color="cyan lighten-4">{{c.issuer}}</v-chip></v-col>
          <v-col cols="4" sm="3">{{c.priceUsd | unitPrice(coin, 'USD', 2)}}<span class="grey--text"> (/{{blockchain[coin].unit}})</span></v-col>
          <v-col cols="3" v-if="$vuetify.breakpoint.smAndUp">{{c.volume}} <span class="grey--text">{{blockchain[coin].unit}}</span></v-col>
          <v-col cols="4" sm="3" class="dealROI"><colored :value="c.breakevenDays" format="breakeven" /></v-col>
        </v-row>

        <v-chip small color="#ffe500" class="ma-2 font-weight-bold" v-if="coin === 'BTC'">Difficulty Futures</v-chip>
        <v-row
                justify="space-between"
                align="center"
                align-content="center"
                class="caption d-flex"
                style="margin: 0;"
        >
          <v-col cols="6">Name</v-col>
          <v-col cols="6">Implied Price</v-col>
        </v-row>
        <v-row v-for="c of findContracts('DIFFICULTY_FUTURES', coin)" :key="c.id" justify="space-between" align="center" align-content="center" class="homeDeal v-card--hover">
          <v-col cols="6">{{c.name}} <v-chip small color="cyan lighten-4">{{c.issuer}}</v-chip></v-col>
          <v-col cols="6">{{c.priceUsd / 10 ** 12 | unitPrice(coin, 'USD', 4)}}<span class="grey--text"> (/{{blockchain[coin].unit}}/Day)</span></v-col>
        </v-row>
      </div>
    </v-tab-item>
  </v-tabs>
</template>

<script>
import qs from "querystring";
import { mapState, mapGetters } from "vuex";

import { coins } from "@/api/const";

import Colored from "../Colored";
import CoinSummary from "../CoinSummary";
import SummaryChart from "./SummaryChart";

import { percent, price, unitPrice, unit, hashrate, totalReward } from "../../filters";
import { getValueColor } from "../../utils";

export default {
  name: "Summaries",
  components: { CoinSummary, Colored, SummaryChart },
  computed: {
    ...mapState("product", ["slot2", "slot2Menu"]),
    ...mapState(["niceHash", "blockchain"]),
    ...mapGetters("contracts", ["findContracts"]),
    ...mapGetters("cloudMining", ["getSummary"])
  },
  methods: {
    getValueColor,
    goToNicehash(item, coin) {
      location.href = `#/product-realtime?from=home&id=${item.id}&coin=${coin}`;
    },
    goToLifetime(id) {
      location.href = '#/product-lifetime?from=home&id=' + id;
    },
    jump(coin, duration) {
      location.href = "#/products?" + qs.encode({ coin, duration });
    }
  },
  filters: { percent, unit, price, unitPrice, hashrate, totalReward },
  data() {
    return {
      coins,
      activeCoinTab: coins.indexOf(this.$store.state.selectedCoins[0])
    };
  }
}
</script>

<style scoped lang="scss">
.v-card--hover:hover {
  -webkit-box-shadow: 0px 0px 0px 2px rgba(255, 229, 0, 0.8),
  0px 2px 2px 2px rgba(251, 255, 0, 0.2);
  box-shadow: 0px 0px 0px 2px rgba(255, 229, 0, 0.8),
  0px 2px 2px 2px rgba(251, 255, 0, 0.2);
}

.homeDeal{
    margin:12px;
    background: #fafafa;
    border-radius: 6px;
    font-size: 16px;
}
.homeDeal .grey--text{
      font-size: 14px;
}

.dealROI
{
  color: #222;
  background-color: #FFFACC !important;
  text-align: center;
  font-weight: 600;
}

.homeNum{
  font-size: 16px;
  @media only screen and (max-width: 600px) {
    font-size:14px;
  }
}


.costCol{
      display: block;
    }

.diagramTitle{
    background: #ffe500;
    box-shadow: 1px 2px 4px #888888;
    color: black;
    margin-bottom: -20px;
    z-index: 1000;
    padding: 12px;
}

@media only screen and (max-width: 600px) {
    .costCol{
      display: none;
    }
  .tableHeader .col{
    flex-basis: auto;
  }

  .dealsTab{
    margin-top: -20px;
  }
}
</style>